import React, { createContext, useContext } from 'react';
import { useThemeMode } from '../hooks/useThemeMode';

interface ThemeContextType {
  themeMode: 'light' | 'dark' | 'retro';
  toggleTheme: (ctrlKey?: boolean) => void;
  isDarkMode: boolean;
  toggleDarkMode: () => void;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const themeMode = useThemeMode();
  
  return (
    <ThemeContext.Provider value={themeMode}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useThemeContext() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useThemeContext must be used within ThemeProvider');
  }
  return context;
}